import {
  ConsentService,
  GetTermsServiceInput,
  GetTermsServiceOutput,
  SendConsentServiceInput,
  SendConsentServiceOutput,
} from '@core/model/service/consentService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import type { HttpClient } from '@core/model/framework/httpClient';
import { Ok } from '@core/model/framework/Result/OkResult';
import { Result } from '@core/model/framework/Result/Result';
import { GetTermsResponse } from './types/request-response/getTerms';
import { PostConsentRequest, PostConsentResponse } from './types/request-response/postConsent';

@injectable()
export class DFConsentService implements ConsentService {
  constructor(
    @inject(SERVICE_ID.openBankingHttpClient)
    private readonly httpClient: HttpClient
  ) {}
  async getTerms(input: GetTermsServiceInput): GetTermsServiceOutput {
    const { userToken } = input;

    const result = await this.httpClient.get<GetTermsResponse>(`/terms`, {
      Authorization: `Bearer ${userToken}`,
    });

    const terms = Result.unwrap(result).data;

    return Ok(terms);
  }

  async sendConsent(input: SendConsentServiceInput): SendConsentServiceOutput {
    const { userToken, userId, hasConsented, termsVersion, cguVersion } = input;

    const request: PostConsentRequest = {
      consent: hasConsented,
      documentVersions: {
        termsVersion,
        cguVersion,
      },
    };

    const result = await this.httpClient.post<PostConsentResponse, PostConsentRequest>(
      `/users/${userId}/consent`,
      request,
      {
        Authorization: `Bearer ${userToken}`,
        Accept: 'application/vnd.oney+json;version=2.0',
      }
    );

    Result.unwrap(result);
    return Ok();
  }
}
